import React from 'react'
import { Button, ButtonProps } from 'antd'
import cn from 'classnames'
import styles from './OrangeButton.module.scss'
import type { GetRef } from 'antd'

type ButtonRef = GetRef<typeof Button>

export const OrangeButton = React.forwardRef<ButtonRef, ButtonProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        className={cn(styles.button, className)}
        {...props}
      >
        {children}
      </Button>
    )
  }
)

OrangeButton.displayName = 'OrangeButton'